/**
 * cart/constants.ts — Cart-wide tunables.
 *
 * T7.S6.13 — Cart edge cases.
 *
 * MAX_QTY_PER_LINE: default per-variant-per-order ceiling. Mirrored by:
 *   - the cart UI clamp (CartLineRow + qty input)
 *   - the server-side validator (/api/cart/validate)
 *   - the checkout body schema (CartLineSchema in /api/checkout)
 *
 * Update all three locations if this constant changes.
 */
export const MAX_QTY_PER_LINE = 10
export const MAX_CART_LINES = 50
